import React from "react";
import Table from "../../Common/Table/index";
import styled from "styled-components";
import { FlexContainer } from "../../../constants/assets/containers";

const tableFields = [
    {
        heading: "Order ID",
        key: "order_id",
    },
    {
        heading: "Locality ID",
        key: "locality_id",
    },
    {
        heading: "Intensity Levels",
        key: "intensity",
    },
];

const RainIntensity = ({ intensity }) => {
    const getActiveElemnt = (item, key) => item[key];

    const intensityArray = (intensity?.order_rain_intensities || []).map(order => ({
        order_id: order.order_id,
        locality_id: order.locality_id,
        intensity: order.levels.join(", ") 
    }));

    return (
        <FlexContainer justify={"flex-start"} align={"flex-start"}>
            <RainIntensityCard>
                {intensityArray.length ? (
                    <Table fields={tableFields} list={intensityArray} getFieldValue={getActiveElemnt} />
                ) : (
                    <p>Rain intensity details are not present</p>
                )}
            </RainIntensityCard>
        </FlexContainer>
    );
};

export default RainIntensity;

const RainIntensityCard = styled.div`
  margin: 10px;
  width: 50%;
`;
